/**
 * Device Intelligence Page
 *
 * Re-exports the DeviceIntelPage component from device-intel module.
 */

import { DeviceIntelPage } from '../device-intel';

export default DeviceIntelPage;
